import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import EarlyAccessModal from './components/EarlyAccessModal';
import { EarlyAccessProvider } from './context/EarlyAccessContext';
import HomePage from './pages/HomePage';
import ExploreCurriculumPage from './pages/ExploreCurriculumPage';
import AboutUsPage from './pages/AboutUsPage';
import PublicRoadmapPage from './pages/PublicRoadmapPage';

function App() {
  return (
    <EarlyAccessProvider>
      <BrowserRouter>
        <div className="app">
          <Nav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/curriculum" element={<ExploreCurriculumPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/roadmap" element={<PublicRoadmapPage />} />
          </Routes>
          <Footer />
          <EarlyAccessModal />
        </div>
      </BrowserRouter>
    </EarlyAccessProvider>
  );
}

export default App;
